import React from 'react';
import { Link } from 'react-router-dom';

const Logout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-tertiary via-neutral-warm to-tertiary flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          <div className="mb-6">
            <svg className="w-20 h-20 mx-auto text-primary mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <h1 className="text-3xl font-light text-primary mb-2">
              You've Been Logged Out
            </h1>
            <p className="text-primary-light">
              Thank you for visiting Key Electrolysis Services. You have been successfully logged out of your account.
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/login"
              className="block w-full bg-gradient-to-r from-accent to-accent-dark text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              Log Back In
            </Link>
            <a
              href={process.env.REACT_APP_MAIN_SITE_URL || 'https://keyelectrolysis.com'}
              className="block w-full bg-white border-2 border-primary text-primary px-8 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-all duration-300"
            >
              Return to Main Site
            </a>
            <Link
              to="/"
              className="block w-full text-primary hover:text-accent transition-colors"
            >
              Book an Appointment
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
